import React from "react";
import StepNavigation from "../../components/addListing/StepNavigation";
import { useTranslation } from "react-i18next";
import "../../styles/steps.css";

export default function StepRenovationAvailability({
  listing,
  setListing,
  onBack,
  onNext,
}) {
  const { t } = useTranslation();

  const toggleOption = (field) => {
    setListing((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  const isNextDisabled =
    !listing.storeAvailable &&
    !listing.productionAvailable &&
    !listing.deliveryAvailable;

  return (
    <div className="step">

      <h2 className="step-title">
        {t("renovation.stepAvailabilityTitle")}
      </h2>

      <p className="step-subtitle">
        {t("renovation.stepAvailabilitySubtitle")}
      </p>


      {/* =========================
          AVAILABILITY OPTIONS
      ========================== */}

      <div className="option-grid">

        {/* STORE */}

        <button
          type="button"
          className={`option-card ${
            listing.storeAvailable ? "active" : ""
          }`}
          onClick={() => toggleOption("storeAvailable")}
        >
          🏪{" "}
          {t("renovation.storeAvailable")}

          {listing.storeAvailable && (
            <span> ✓</span>
          )}
        </button>


        {/* PRODUCTION / WAREHOUSE */}

        <button
          type="button"
          className={`option-card ${
            listing.productionAvailable ? "active" : ""
          }`}
          onClick={() =>
            toggleOption("productionAvailable")
          }
        >
          🏭{" "}
          {t("renovation.productionAvailable")}

          {listing.productionAvailable && (
            <span> ✓</span>
          )}
        </button>


        {/* DELIVERY */}

        <button
          type="button"
          className={`option-card ${
            listing.deliveryAvailable ? "active" : ""
          }`}
          onClick={() =>
            toggleOption("deliveryAvailable")
          }
        >
          🚚{" "}
          {t("renovation.deliveryAvailable")}

          {listing.deliveryAvailable && (
            <span> ✓</span>
          )}
        </button>

      </div>


      {/* =========================
          STORE LOCATION
      ========================== */}

      {listing.storeAvailable && (
        <div className="renovation-availability-section">

          <h3 className="step-subtitle">
            {t("renovation.storeLocation")}
          </h3>

          <input
            type="text"
            className="step-input"
            value={listing.storeAddress || ""}
            onChange={(e) =>
              setListing((prev) => ({
                ...prev,
                storeAddress: e.target.value,
              }))
            }
            placeholder={t(
              "renovation.storeAddressPlaceholder"
            )}
          />

          <label className="checkbox-row">

            <input
              type="checkbox"
              checked={listing.pickupAvailable || false}
              onChange={(e) =>
                setListing((prev) => ({
                  ...prev,
                  pickupAvailable: e.target.checked,
                }))
              }
            />

            {t("renovation.pickupAvailable")}

          </label>

        </div>
      )}


      {/* =========================
          PRODUCTION LOCATION
      ========================== */}

      {listing.productionAvailable && (
        <div className="renovation-availability-section">

          <h3 className="step-subtitle">
            {t("renovation.productionLocation")}
          </h3>

          <input
            type="text"
            className="step-input"
            value={listing.productionAddress || ""}
            onChange={(e) =>
              setListing((prev) => ({
                ...prev,
                productionAddress: e.target.value,
              }))
            }
            placeholder={t(
              "renovation.productionAddressPlaceholder"
            )}
          />

        </div>
      )}


      {/* =========================
          NAVIGATION
      ========================== */}

      <StepNavigation
        onBack={onBack}
        onNext={onNext}
        nextDisabled={isNextDisabled}
      />

    </div>
  );
}
